module.exports = __webpack_public_path__ + "img/1.bd9feac7.svg";